import { Link } from "react-router-dom";
import { Beef, ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen grain relative z-10 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white text-sm mb-6">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center"><Beef className="w-5 h-5 text-white" /></div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </div>
        <div className="cw-card p-8 sm:p-10 prose prose-invert">
          <h1 className="text-3xl font-display font-extrabold mb-1">Termos de Uso</h1>
          <p className="text-xs text-zinc-500 mb-6">Última atualização: 25 de setembro de 2026</p>

          <section className="space-y-4 text-zinc-300 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-bold text-white mb-2">1. Sobre o CarnesWork</h2>
              <p>O CarnesWork é uma plataforma digital que conecta comércios do setor de carnes (açougues, casas de carnes e supermercados) a profissionais autônomos (açougueiros, balconistas, desossadores e auxiliares) para a contratação de diárias. Somos apenas o meio; o vínculo comercial é sempre entre comércio e profissional.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">2. Cadastro e Elegibilidade</h2>
              <p>Para se cadastrar, o usuário deve ter 18 anos ou mais e fornecer dados verdadeiros. Comércios devem informar CNPJ válido; profissionais devem informar CPF válido. Contas falsas ou com dados incorretos podem ser suspensas.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">3. Publicação e Aceite de Diárias</h2>
              <p>O comércio publica a diária com valor, data, horário e local. O profissional aceita ou faz contra-oferta. Ao aceitar, ambas as partes assumem o compromisso combinado. O pagamento é realizado diretamente pelo comércio ao profissional ao fim do expediente, no valor final acordado na plataforma.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">4. Taxa da Plataforma</h2>
              <p>Apenas o <strong>comércio</strong> paga taxa mensal de assinatura Premium (R$ 29,90/mês, com 14 dias grátis). O profissional <strong>não paga nenhuma taxa</strong> para usar a plataforma. O CarnesWork não retém percentual da diária.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">5. Cancelamentos e Anti-Furo</h2>
              <p>O profissional pode cancelar uma diária aceita, e a vaga volta ao feed automaticamente. Cancelamentos causam perda de pontos e reset da sequência de fidelidade. Cancelamentos repetidos podem levar à suspensão. Combinar serviço "por fora" da plataforma após conhecer o comércio via CarnesWork é vedado.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">6. Avaliações e Ranking</h2>
              <p>Após cada diária concluída, ambas as partes se avaliam com estrelas. Avaliações são exibidas publicamente. Comentários difamatórios ou ofensivos podem ser removidos.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">7. Responsabilidades</h2>
              <p>O CarnesWork <strong>não</strong> é empregador nem intermediador trabalhista. Nenhum vínculo empregatício é criado entre o comércio, o profissional e a plataforma. Cada usuário responde pelos seus atos.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">8. Conta e Encerramento</h2>
              <p>Você pode encerrar sua conta a qualquer momento. Podemos suspender contas que violem estes Termos, sem aviso prévio em casos graves.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">9. Alterações</h2>
              <p>Podemos atualizar estes Termos. Alterações relevantes serão comunicadas por email ou pelo app.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">10. Contato</h2>
              <p>Dúvidas? <a className="text-red-500" href="mailto:edinaldoalvesdasilva8@gmail.com">edinaldoalvesdasilva8@gmail.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
